import "./instrument";
import { createRoot } from "react-dom/client";
import App from "./App";
import * as Sentry from "@sentry/react";

const container = document.getElementById("root");
const root = createRoot(container!, {
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
});
root.render(<App />);
